import Select from 'app/frontend/base/components/Select'

interface Props {
  minKeyLevel?: number
  setMinKeyLevel: (level?: number) => void
}

const minKeyLevelOptions = Array.from({ length: 18 }, (_, index) => ({
  label: `> ${index + 2}`,
  value: (index + 3).toString(),
  sortLabel: '',
}))

const KeystoneLevelFilter = ({ minKeyLevel, setMinKeyLevel }: Props) => {
  return (
    <Select
      value={minKeyLevel?.toString()}
      setValue={(value) => setMinKeyLevel(value ? Number(value) : undefined)}
      options={minKeyLevelOptions}
      isClearable
      optionWidth='fit'
      placeholder='any level'
      className='h-6 text-sm font-normal'
    />
  )
}

export default KeystoneLevelFilter
